// @react/hooks/useCalendarEvent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { calendarEventStore } from '@core/stores';

/**
 * React hook for CalendarEvent operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useCalendarEvent } from '@react/hooks';
 *
 * const CalendarEventList = observer(() => {
 *   const store = useCalendarEvent();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useCalendarEvent() {
  return calendarEventStore;
}
